import { toast } from 'react-toastify';

const typeList = {
  inf: 'info',
  war: 'warning',
  err: 'error',
  suc: 'success',
};

function setUiMessage(type = '', message = 'No response!', option = '') {
  toast(
    message,
    option || {
      type: typeList[type] || '',
      position: 'top-center',
      theme: 'colored',
      autoClose: 3000,
    }
  );
}

export default setUiMessage;
